export enum RebateRecordErrorTypeModel {
	Error = 1,
	Warning = 2
}
